import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {apiConfig} from "../../api/ApiConfig";
import {
    EmailSuccess, EmailError, EmailLoader, EmailMessageContainer, EmailLoaderLayout
} from "../../style/StyledElement";

const {verifyEmailActivationToken} = apiConfig();

export const EmailConfirmation = () => {
    const {actToken} = useParams();
    const [status, setStatus] = useState('loading');

    console.log(actToken);

    useEffect(() => {
        const verifyEmail = async () => {
            try {
                const response = await verifyEmailActivationToken(actToken, false)
                console.log(response);
                if (response === 'true') {
                    setStatus('success');
                } else {
                    setStatus('error');
                }
            } catch (error) {
                setStatus('error');
            }
        };

        if (actToken) {
            verifyEmail();
        } else {
            setStatus('error');
        }
    }, [actToken]);

    const handleResendActToken = async () => {
        try {
            setStatus('loading');
            const response = await verifyEmailActivationToken(actToken, true)
            console.log(response);
            if (response === 'true') {
                setStatus('resend success');
            } else {
                setStatus('resend error');
            }
        } catch (error) {
            setStatus('resend error');
        }
    }

    return (
        <EmailMessageContainer>
            <EmailLoaderLayout>
                {status === 'loading' && (
                    <EmailLoader>
                        <div className="loading-icon"/>
                        <h2 className="h2-loader">Verifying your email...</h2>
                    </EmailLoader>
                )}

                {status === 'success' && (
                    <EmailSuccess>
                        <div className="success-tick">
                            <svg className="svg-success" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"/>
                            </svg>
                        </div>
                        <h2 className="h2-success">Email verified successfully!</h2>
                        <p className="p-success">Your account has been activated.</p>
                        <button
                            onClick={() => window.location.href = '/login'}
                            className="btn-login"
                        >
                            Login
                        </button>
                    </EmailSuccess>
                )}

                {status === 'error' && (
                    <EmailError>
                        <div className="error-tick">
                            <svg className="svg-error" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                      d="M6 18L18 6M6 6l12 12"/>
                            </svg>
                        </div>
                        <h2 className="h2-error">Verification failed.</h2>
                        <p className="p-error">The verification link is invalid or has expired.</p>
                        <button
                            onClick={ handleResendActToken }
                            className="btn-login"
                        >
                            Resend
                        </button>
                    </EmailError>
                )}

                {status === 'resend error' && (
                    <EmailError>
                        <div className="error-tick">
                            <svg className="svg-error" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                      d="M6 18L18 6M6 6l12 12"/>
                            </svg>
                        </div>
                        <h2 className="h2-error">Oops! Failed to resend activation token</h2>
                        <p className='p-error'>Please retry after some time or contact the support team.</p>
                        <button
                            onClick={handleResendActToken}
                            className="btn-login"
                        >
                            Resend
                        </button>
                    </EmailError>
                )}

                {status === 'resend success' && (
                    <EmailSuccess>
                        <div className="success-tick">
                            <svg className="svg-success" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"/>
                            </svg>
                        </div>
                        <h2 className="h2-success">Yay! Successfully resent the activation token.</h2>
                    </EmailSuccess>
                )}
            </EmailLoaderLayout>
        </EmailMessageContainer>
    );
}